import {Injectable} from '@angular/core';
import {Router, Route, ActivatedRouteSnapshot, CanLoad, CanActivate, CanActivateChild, CanDeactivate} from '@angular/router';
import {Observable} from 'rxjs';

import {AppService} from "@api";
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';
import {SistemaService} from "./Sistema.Service";
import {UsuarioService} from './Usuario.service';

@Injectable()
export class SeguridadService implements CanActivate, CanActivateChild, CanLoad {
    constructor(private appService: AppService, private router: Router, private sistemaService: SistemaService, private usuarioService: UsuarioService) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return new Observable(
            observer => {
                this.ValidarDatosSesion(route.data).then((valido: any) => {
                    observer.next(valido);
                    observer.complete();
                });

            }
        );
    }

    canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {

        return new Observable(
            observer => {
                observer.next(true);
                observer.complete();
            }
        );
    }


    canLoad(route: Route): Observable<boolean> {

        return new Observable(
            observer => {
                this.ValidarDatosSesion(route.data).then((valido: any) => {
                    observer.next(valido);
                    observer.complete();
                });
            });

    }

    ValidarDatosSesion(data: any) {
        return new Promise((resolve, reject) => {
            if (data.modulo == "externo") {
                return resolve(true);
            }
            if (!this.sistemaService.datosInicialesCargados) {
                this.appService.Get("inicio/parametros").then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.sistemaService.parametros = res.data;
                        this.sistemaService.datosInicialesCargados = true;
                    }

                    if (!this.sistemaService.permisosCargados && data.modulo != 'sesion') {
                        this.usuarioService.LoadPermisos().then(() => {
                            return resolve(this.ValidarAcceso(data));
                        });
                    } else {
                        return resolve(this.ValidarAcceso(data));
                    }

                }).catch(err => {
                    reject()
                })
            } else {
                if (!this.sistemaService.permisosCargados && data.modulo != 'sesion') {
                    this.usuarioService.LoadPermisos().then(() => {
                        return resolve(this.ValidarAcceso(data));
                    });
                } else {
                    return resolve(this.ValidarAcceso(data));
                }
            }
        });
    }

    ValidarAcceso(data: any) {
        if (localStorage.getItem(this.sistemaService.localStoreVariable.JWT)) {
            if (data.modulo == 'app') {
                if (!this.sistemaService.usuario.reiniciarcontrasena) {
                    return true;
                }
                else {
                    this.router.navigateByUrl('/app/cambiarPassword');
                    return false;
                }
            }
            else if (data.modulo == 'cambiarpassword') {
                return true;
            }
            else if (data.modulo == 'sesion') {
                this.router.navigateByUrl('/app/PantallaInicio');
                return false;
            }
        }
        else {
            if (!data.modulo) {
                return true;
            }
            else if (data.modulo != 'sesion') {
                this.router.navigateByUrl('/inicio');
                return false;
            }
            else {
                return true;
            }

        }

        return true;
    }

}
